import React from "react";
import { FitSize } from "@/components";
import useEffectStore from "@/stores/effectStore";
import { withPublicPath } from "@/utils";
import styles from "./index.module.scss";
import clsx from "clsx";
import { IconReUpload } from "@/assets/icons";

export default function CreatePage() {
  const blobUrl = useEffectStore(
    (state) => state.fileOptions.uploadFile?.blobUrl
  );
  const width = useEffectStore((state) => state.fileOptions.uploadFile?.width);
  const height = useEffectStore(
    (state) => state.fileOptions.uploadFile?.height
  );
  const importFileLoading = useEffectStore((state) => state.importFileLoading);
  // let importFileLoading = true; 

  return (
    <div className={styles.wrapper}>
      <FitSize childrenHeight={height || 1} childrenWidth={width || 1}>
        {!importFileLoading && <img
          src={blobUrl}
          alt=""
          className={clsx(
            styles.main_image
          )}
          onContextMenu={(e) => e.preventDefault()}
        />}
        {(importFileLoading || !blobUrl) && <div className={clsx(styles.loading_img, "skeleton_loading")}></div>}
        <div className={clsx(styles.tool_component, styles.right_top_tool)}>
          <div
            className={styles.tool_btn}
            onClick={() => {
              useEffectStore.getState().selectImage("reupload_photo");
            }}
          >
            <IconReUpload/>
          </div>
        </div>
      </FitSize>
    </div>
  );
}
